import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, Subject, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Process } from '../Interface/Process';
import { RestService } from './rest-service';

@Injectable({
  providedIn: 'root',
})
export class ProcessService extends RestService {
  endpoint = `${environment.api}`;

  // Signal for process list refresh
  private _refreshProcessList = signal(0);
  get refreshProcessList() {
    return this._refreshProcessList;
  }
  
  processCreate(formData: object) {
    return this.http.post<Process>(
      `${this.endpoint}process/process-create/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshProcessList.update(count => count + 1);
      })
    );
  }
  processUpdate(formData: object) {
    return this.http.put<Process>(
      `${this.endpoint}process/process-update/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshProcessList.update(count => count + 1);
      })
    );
  }
  
  processList(processListData: object, currentPage:number, pageSize:number) {
   
    return this.http.post<Process>(
      `${this.endpoint}process/all-process-list/?page=${currentPage}&&page_size=${pageSize}`,
      processListData
    );
  }
  
  getProcessDetails(processListData: {}) {
    return this.http.post<Process>(
      `${this.endpoint}process/get-process-details/`,
      processListData
    );
  } 
  
  processListExceptDependentField(processListData: object, currentPage:number, pageSize:number) {
    return this.http.post<Process>(
      `${this.endpoint}process/all-process-list-except-dependent/?page=${currentPage}&&page_size=${pageSize}`,
      processListData
    );
  }
  
  processSaveOrder(formData: object){
    return this.http.put<Process>(
      `${this.endpoint}process/all-process-list-order/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshProcessList.update(count => count + 1);
      })
    );
  }
  
  makeFormStepHidden(formData: object){
    return this.http.put<Process>(
      `${this.endpoint}process/make-process-hidden/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshProcessList.update(count => count + 1);
      })
    );
  }
}
